import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SaveScreenDialogOperations } from '../../save-screen-dialog/save-screen-dialog.view-model';
import { DashboardDialogConfig } from './dashboard-dialog.model';

@Injectable()
export class DashboardDialogService {

    _close$: Subject<any> = new Subject<any>();
    _open$: Subject<DashboardDialogConfig> = new Subject<DashboardDialogConfig>();
    _result$: Subject<any> = new Subject<any>();
    _toggleLoading$: Subject<boolean> = new Subject<boolean>();

    open(opType: string = SaveScreenDialogOperations.CREATE, data?: any) {
        const config: DashboardDialogConfig = {
            opType: opType,
            config: data
        };
        this._open$.next(config);
        return this._result$;
    }
    toggleLoading(loading) {
        this._toggleLoading$.next(loading);
    }
    close() {
        this._close$.next();
    }
}
